import type { Camera, WebGLRenderer } from 'three';

export function getActiveCamera(renderer: WebGLRenderer | null | undefined, camera: Camera) {
  if (renderer?.xr?.isPresenting) {
    const webxrCamera = renderer.xr.getCamera();
    return webxrCamera.cameras?.[0] ?? camera;
  }
  return camera;
}
